export default "__VITE_ASSET__e1134b24__"